<template>
  <div>
    <PC v-if="isPC" />
    <PHONE v-else />
  </div>
</template>

<script>
import PC from './pc'
import PHONE from './phone'
import { isPC, isPhone, isPad } from '@/common/common.js'
export default {
  components: { PC, PHONE },
  data () {
    return {
      isPhone: isPhone,
      isPC: isPC || isPad
    }
  },
  created () {
    if (this.isPC) {
      document.body.style.minWidth = '1200px'
    } else {
      document.body.style.minWidth = 'auto'
      let metaEl = document.createElement('meta');
      metaEl.setAttribute('name', 'viewport');
      metaEl.setAttribute('content', 'width=device-width,initial-scale=1.0,user-scalable=no');
      document.head.appendChild(metaEl);
    }
  }
}
</script>